/* eslint-disable no-restricted-syntax */
import React, { Component } from 'react';
import { colors } from '~/layout';
import * as lib from '~/dependencies';

class AudioVisualiser extends Component {
  constructor(props) {
    super(props);
    this.canvas = React.createRef();
  }

  componentDidUpdate() {
    this.draw();
  }

  draw() {
    const { audioData, barColor } = this.props;
    const canvas = this.canvas.current;
    const { height } = canvas;
    const { width } = canvas;
    const context = canvas.getContext('2d');

    context.lineWidth = 2;
    context.strokeStyle = colors.darkBlue;
    context.clearRect(0, 0, width, height);

    // eslint-disable-next-line no-unused-vars
    for (const item of audioData) {
      const y = (item / 255.0) * width;
      context.fillStyle = barColor;
      context.fillRect(0, 0, y - 148, 25);
    }
  }

  render() {
    return <canvas width="295" height="17" ref={this.canvas} />;
  }
}

AudioVisualiser.defaultProps = {
  audioData: [],
  barColor: '#2C4F9E',
};

AudioVisualiser.propTypes = {
  audioData: lib.PropTypes.instanceOf(Object),
  barColor: lib.PropTypes.string,
};

export default AudioVisualiser;
